import { Component } from '@angular/core';
import { CommonService } from 'src/app/services/common-services/common.service';
interface Team {
  role: string;
  image: string;
  name: string;
}
@Component({
  selector: 'app-teams',
  templateUrl: './teams.component.html',
  styleUrls: ['./teams.component.scss']
})

export class TeamsComponent {
  teamMembers:Team[] = [];
  constructor(private commonService: CommonService){}
  ngOnInit(){
    this.getTeams();
  }
  getTeams(){
    let apiUrl = 'assets/json/teams.json';
    this.commonService.getData(apiUrl).subscribe({
      next: (res:any) =>{
        this.teamMembers = res.data;
      }
    })
  }
}
